export const magnetboardDiagnosticsEnabled = () => (
  typeof window !== 'undefined' &&
  window.localStorage &&
  window.localStorage.getItem('edario_magnetboard_diagnostics') === '1'
);

export const getDiagnosticTimestamp = () => (
  typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now()
);

export const logMagnetboardDiagnostic = (label, details = {}) => {
  if (!magnetboardDiagnosticsEnabled()) return;

  console.info(`[magnetboard] ${label}`, {
    at_ms: Math.round(getDiagnosticTimestamp()),
    ...details,
  });
};

export const startMagnetboardDiagnosticTimer = (label, details = {}) => {
  if (!magnetboardDiagnosticsEnabled()) return () => {};

  const started_at = getDiagnosticTimestamp();
  logMagnetboardDiagnostic(`${label}:start`, details);

  return (end_details = {}) => {
    const duration_ms = Math.round(getDiagnosticTimestamp() - started_at);
    logMagnetboardDiagnostic(`${label}:end`, {
      ...details,
      ...end_details,
      duration_ms,
    });
  };
};
